(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RouteController', RouteController);

    RouteController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Route', '$q', '$uibModal',
        'ConfirmationService'];

    function RouteController(GenericEntityDatatableService, CoreService, Route, $q, $uibModal,
                             ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Routes',
            newButtonTitle: 'New Route',
            entityClassHumanized: 'Route',
            entityStateName: 'route',
            service: Route,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Route',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/route/update/route-dialog.html',
                controller: 'RouteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/route/update/route-dialog.html',
                controller: 'RouteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Route', function (Route) {
                        return Route.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Route').result.then(function () {
                    Route.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
